import { MarketplaceItemList } from '@/apis/marketplace/marketplace.schema'
import { CustomQueryOptions } from '@/common/types_and_interfaces'
import { useQuery } from '@tanstack/react-query'
import { GETMarketplacePreviewItems } from '../requests'
import { MARKETPLACE_PREVIEW_QUERY_KEYS } from './keys'
import { MarketplaceAccessMode } from '../types'

export type MarketplacePreviewItemsParams = {
  perPage: number
  page: number
  search: string
  business_type: string
  affiliation_id?: number
  provider_id?: number
}

export const useMarketplacePreviewItems = (
  params: MarketplacePreviewItemsParams,
  mode: MarketplaceAccessMode = 'preview',
  options: CustomQueryOptions<MarketplaceItemList> = {}
) => {
  return useQuery({
    queryKey: MARKETPLACE_PREVIEW_QUERY_KEYS.items(mode, params),
    queryFn: () => GETMarketplacePreviewItems(params, mode),
    ...options,
  })
}
